export const ProductSnapshot = () => {
  const $productSnapshop = document.querySelector("section.product-snapshot");

  if ($productSnapshop) {
    const $snapshotButton = $productSnapshop.querySelector(
      ".product-snapshot__button"
    );

    const $snapshotFlyout = $productSnapshop.querySelector(
      ".product-snapshot__terminology-flyout"
    );

    if ($snapshotButton && $snapshotFlyout) {
      const $topClose = $snapshotFlyout.querySelector(".top__close");

      $snapshotButton.addEventListener("click", (event) => {
        event.preventDefault();
        $snapshotFlyout.classList.remove("opacity-0", "pointer-events-none");
      });

      $topClose.addEventListener("click", (event) => {
        event.preventDefault();
        $snapshotFlyout.classList.add("opacity-0", "pointer-events-none");
      });

      $snapshotFlyout.addEventListener("click", (event) => {
        if (event.target === $snapshotFlyout) {
          $snapshotFlyout.classList.add("opacity-0", "pointer-events-none");
        }
      });
    }
  }
};

export default ProductSnapshot;
